module.exports = __webpack_public_path__ + "img/machine-learning-logo.a369add1.svg";